export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";